import React from "react";
import Badge from "react-bootstrap/Badge";
import Colors from "lookup/Colors.json";
import { formatPhoneNumber } from "services/UtilityService";
import "./Timeline.css";
import "react-vertical-timeline-component/style.min.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import InconclusiveBadge from "components/InconclusiveBadge";
import BypassAutoDispositionBadge from "components/BypassAutoDispositionBadge";

// move these out to css
const styles = {
  dateStyle: {
    backgroundColor: "unset",
  },
  dateInnerStyle: {
    textIndent: 15,
    fontSize: "0.9em",
  },
  timelineTitle: {
    fontSize: "1.1em",
    letterSpacing: "1px",
    wordBreak: "break-word",
  },
  timelineBody: {
    fontSize: "0.85em",
  },
};
const getTimelineBodyForStatus = (data) => {
  if (data.status === "RECEIVED_PRESCRIBER_FAX" || data.status === "PROCESSING_PRESCRIBER_FAX") {
    return (
      <span id="recived-form">
        Received from: {formatPhoneNumber(data.from)}
        <br />
      </span>
    );
  }

  else if (data.status.includes("NOTIFICATION") && data.to) {
    return (
      <span id="recived-form">
        Recipient: {formatPhoneNumber(data.to)}
        <br />
      </span>
    );
  }

  else if (data.status.indexOf("_FAX") >= 0) {
    if (data.status.indexOf("WAITING_") >= 0) {
      return (
        <Badge pill bg="warning">
          Activity created for missing fax
        </Badge>
      );
    } else if (data.status.indexOf("ERROR_") < 0) {
      return (
        <span id="recipient-number">
          Recipient: {formatPhoneNumber(data.to)}
        </span>
      );
    }
  } else if (data.status === "PENDING_RESPONSE_REVIEW") {
    return (
      <span id="forwarded-to-paw-for-response-evalutaion">
        Forwarded to PAW for response evaluation
      </span>
    );
  } else if (data.status.indexOf("_FOLLOWUP") >= 0) {
    return (
      <span id="container">
        <span id="assigned-for-response-evalutaion">
          Assigned to{" "}
          {data.status === "ACCEPTED_RESPONSE_FOLLOWUP" ? "SWIM" : "PAW"} for
          response evaluation
        </span>
        {data.bypassAutoDisposition ? (
          <>
            <br />
            <BypassAutoDispositionBadge
              responseTypeList={data.responseTypeList}
            />
          </>
        ) : (
          <InconclusiveBadge
            inconclusiveResult={data.inconclusiveResult}
            responseTypeList={data.responseTypeList}
          />
        )}
        <br />
        {data.confirmedDisposition ? (
          <span id="confirmed-dispoition">
            Confirmed Disposition: &nbsp;
            <Badge
              pill
              style={{ textTransform: "capitalize" }}
              bg={
                data.confirmedDisposition === "DECLINED" ? "danger" : "success" //submitted via ehr and approved
              }
            >
              {data.confirmedDisposition}
            </Badge>
          </span>
        ) : null}
      </span>
    );
  } else if (data.status === "AWAITING_FILL_AND_PICKUP") {
    return (
      // <span>Since <u>{data.date}</u></span>
      null
    );
  } else if (data.status === "COMPLETED") {
    return (
      <span id="verified-through-claim">
        Verified through Claim # {data.claimNumber} received on{" "}
        {data.claimReceivedDate}
      </span>
    );
  } else if (data.status === "CLAIMS_RECEIVED") {
    return (
      <span id="claims-recevied-from">
        Claims received from {data.clientName} on {data.claimReceivedDate}
      </span>
    );
  } else return null;
};

export const StatusTimelineItem = (props) => {
  const { data, style = {} } = props;
  const color = style.color || Colors["rm-blue"];
  const contentArrowStyle =
    props.contentArrowStyle || { borderRight: `7px solid ${color}` };

   const rawDateInner = props.dateInnerStyle || {};
   const bgFromDate =
     rawDateInner.background || rawDateInner.backgroundColor || undefined;
   const dateTextColor = rawDateInner.color || bgFromDate || color;
   const dateStyle = {
     ...styles.dateInnerStyle,
     ...rawDateInner,
     background: "unset",
     backgroundColor: "unset",
     color: dateTextColor,
   };

  return (
    <div className="vertical-timeline-element">
      <span
        className="vertical-timeline-element-icon"
        style={{ background: color, color: "#fff" }}
      />
      <div className="vertical-timeline-element-content">
        <div
          className="vertical-timeline-element-content-arrow"
          style={contentArrowStyle}
        />
        <span
          className="vertical-timeline-element-date grouped-state-title"
          style={dateStyle}
        >
          {props.dateText}
        </span>
        {!data ? null : (
          <span>
            <div
              id={"timelineStatusItem " + data.status}
              style={{ ...styles.timelineTitle, color }}
            >
              {data.status}
            </div>
            {props.showDate ? (
              <div className="text-muted">{data.date}</div>
            ) : null}
            <div style={styles.timelineBody}>
              {getTimelineBodyForStatus(data)}
            </div>
          </span>
        )}
        {props.children}
      </div>
    </div>
  );
};

export const Timeline = (props) => {
  const { className = "" } = props;
  return (
    <div
      className={`vertical-timeline vertical-timeline--animate vertical-timeline--one-column-left rm-timeline ${className}`}
    >
      {props.children}
    </div>
  );
};
